import axios from "axios";
import React, { useState } from "react";
import { getDateFormatted, nFormat } from "../../../Vendor/common";
import DateTimePicker from "react-datetime-picker/dist/DateTimePicker";
import { Button, Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
const Report = () => {
    const [fromDate,setFromDate] = useState()
    const [toDate,setToDate] = useState()
    const [dataSource,setDataSource] = useState([])
    const localStorageWT = localStorage.getItem('OSHEN-LOC-STR-WT');
    const [modal,setModal] = useState(false)
    const [leadSelected,setLeadSelected] = useState(null)
    const closeModal = (modalFire) => {
        setModal(modalFire);
    }
    const searchData = async () => {
        try {
            const resource = await axios.post(`${process.env.REACT_APP_NV_API_PATH}/v1.0/lead/information`,
                {
                    fromDate: getDateFormatted(fromDate),
                    toDate: getDateFormatted(toDate)
                },             
                {
                    headers: {
                        Authorization: `Bearer ${localStorageWT}`
                    }
                }
            ),
            data = resource.data
            setDataSource(data)
        } catch ( error ) {
            console.log('err', error);
            // setLoadingTable(false);
            if ( error.response.status == 401 )
            {
                Swal.fire({
                    icon: 'error',
                    title: 'Unauthorized',
                    text: "Token invalido"
                }).then(()=>{
                    location.href = process.env.REACT_APP_PATH_APP;
                });
                return;
            }            
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: "Error Interno, favor contacte al administrador"
            });
        }
    }
    return (
    <>
        <div className="row mb-3">
            <div className="col-4">
                <label>Desde</label><br />
                <DateTimePicker
                    onChange={setFromDate}
                    value={fromDate}
                    format="dd-MM-y"
                    disableClock={true}
                    // minDate={new Date()}
                />
            </div>
            <div className="col-4">
                <label>Hasta</label><br />
                <DateTimePicker
                    onChange={setToDate}
                    value={toDate}
                    format="dd-MM-y"
                    disableClock={true}
                    // minDate={new Date()}
                />
            </div>
        </div>
        <div className="row mb-3">
            <div className="col">
                <Button variant="primary" onClick={searchData}>
                    Buscar
                </Button>
            </div>
        </div>
        <div className="row">
            <div className="col table-responsive">
                <table className="table" style={{marginBottom: 0}}>
                    <thead>
                        <tr>
                            <th style={{fontSize: 11}}>Ver</th>
                            <th style={{fontSize: 11}}>Oportunidad</th>
                            <th style={{fontSize: 11}}>Cliente</th>
                            <th style={{fontSize: 11}}>Paso</th>
                            <th style={{fontSize: 11}}>Monto</th>
                            <th style={{fontSize: 11}}>Obrar</th>
                            <th style={{fontSize: 11}}>Días de trabajo</th>
                            <th style={{fontSize: 11}}>Fecha de entrega</th>
                            <th style={{fontSize: 11}}>Fecha de suplidor</th>
                            <th style={{fontSize: 11}}>Estatus</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            dataSource.map((source, idxSource) => {
                                return (
                                    <>
                                        <tr key={`tr-row-key-${idxSource}`} className="tr-hover-color">
                                            <td>
                                                <FontAwesomeIcon
                                                    icon={faEye} 
                                                    style={{cursor: 'pointer'}} 
                                                    onClick={()=>{
                                                        setLeadSelected(source)
                                                        setModal(true)
                                                    }}
                                                />
                                            </td>
                                            <td>{source.id}</td>
                                            <td>{source.customer_name}</td>
                                            <td>{source.lead_step}</td>
                                            <td>{`${source.currency_ref} ${nFormat(source.total)}`}</td>
                                            <td>{source.work_id}</td>
                                            <td>{source.work_days}</td>
                                            <td>{getDateFormatted(source.delivery_date)}</td>
                                            <td>{getDateFormatted(source.supplier_date)}</td>
                                            <td>{source.lead_status}</td>
                                        </tr>                                        
                                    </>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        </div>        
        <Modal 
            size="xl" 
            show={modal} 
            onHide={()=>closeModal(!modal)} 
            backdrop="static" keyboard={false}
        >
            <Modal.Header className="custom-modal-header" closeButton>
                <Modal.Title>Detalles De Oportunidad</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{padding: 0}}>
                <div className="card">
                    <div className="card-body">
                        <div className="row mb-3" style={{marginTop: 10}}>
                            <div className="col">
                                {
                                    leadSelected!==null?
                                    <table className="table" style={{marginBottom: 0}}>
                                        <thead>
                                            <tr>
                                                <th colSpan={9}>DATOS GENERALES</th>
                                            </tr>
                                            <tr>
                                                <th style={{fontSize: 11}}>Oportunidad</th>
                                                <th style={{fontSize: 11}}>Cliente</th>
                                                <th style={{fontSize: 11}}>Paso</th>
                                                <th style={{fontSize: 11}}>Monto</th>
                                                <th style={{fontSize: 11}}>Obrar</th>
                                                <th style={{fontSize: 11}}>Días de trabajo</th>
                                                <th style={{fontSize: 11}}>Fecha de entrega</th>
                                                <th style={{fontSize: 11}}>Fecha de suplidor</th>
                                                <th style={{fontSize: 11}}>Estatus</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{leadSelected.id}</td>
                                                <td>{leadSelected.customer_name}</td>
                                                <td>{leadSelected.lead_step}</td>
                                                <td>{`${leadSelected.currency_ref} ${nFormat(leadSelected.total)}`}</td>
                                                <td>{leadSelected.work_id}</td>
                                                <td>{leadSelected.work_days}</td>
                                                <td>{getDateFormatted(leadSelected.delivery_date)}</td>
                                                <td>{getDateFormatted(leadSelected.supplier_date)}</td>
                                                <td>{leadSelected.lead_status}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    :null
                                }                                
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col">
                            {
                                leadSelected!==null&&leadSelected.details.length?
                                    <table className="table bg-table-head-row" style={{marginBottom: 0}}>
                                        <thead>
                                            <tr>
                                                <th colSpan={7}>LISTADO DE ARTÍCULOS</th>
                                            </tr>
                                            <tr>
                                                <th style={{fontSize: 11}}>Artículo</th>
                                                <th style={{fontSize: 11}}>Cantidad</th>
                                                <th style={{fontSize: 11}}>Precio</th>
                                                <th style={{fontSize: 11}}>Desc.</th>
                                                <th style={{fontSize: 11}}>Imp.</th>
                                                <th style={{fontSize: 11}}>Sub-Total</th>
                                                <th style={{fontSize: 11}}>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                leadSelected.details.map(({
                                                    product_code,
                                                    product_des,
                                                    qty,
                                                    unit_des,
                                                    product_price,
                                                    discount_amount,
                                                    tax_amount,
                                                    sub_total,
                                                    total
                                                },idxDetail)=>{
                                                    return (
                                                        <tr key={`tr-row-key-details-row-${idxDetail}`}>
                                                            <td>{`${product_code} | ${product_des}`}</td>
                                                            <td>{`${qty} | ${unit_des}`}</td>
                                                            <td>{`${nFormat(product_price.toFixed(2))}`}</td>
                                                            <td>{`${nFormat(discount_amount.toFixed(2))}`}</td>
                                                            <td>{`${nFormat(tax_amount.toFixed(2))}`}</td>
                                                            <td>{`${nFormat(sub_total.toFixed(2))}`}</td>
                                                            <td>{`${nFormat(total.toFixed(2))}`}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                :null
                            }
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col">
                            {
                                leadSelected!==null&&leadSelected.assigments.length?
                                    <table className="table bg-table-assigments-row" style={{marginBottom: 0}}>
                                        <thead>
                                            <tr>
                                                <th colSpan={7}>LISTADO DE ASIGACIONES</th>
                                            </tr>
                                            <tr>
                                                <th style={{fontSize: 11}}>#</th>
                                                <th style={{fontSize: 11}}>Usuario</th>
                                                <th style={{fontSize: 11}}>Proceso</th>
                                                <th style={{fontSize: 11}}>Estado</th>
                                                <th style={{fontSize: 11}}>Fecha</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                leadSelected.assigments.map((aSource,idxSource)=>{
                                                    let comments = []
                                                    for ( let counter = 0; counter < aSource.comments.length; counter++ ) {
                                                        comments.push(
                                                            <tr key={`row-comment-${counter}`}>
                                                                <td colSpan={5} style={{fontSize: 11,fontWeight: 'bold'}}>
                                                                    Com.#{aSource.comments[counter].id} - {aSource.comments[counter].lead_assigment_comment} | {getDateFormatted(aSource.comments[counter].created_at)}
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                    return (
                                                        <>
                                                            <tr key={`tr-row-key-assigments-row-${idxSource}`}>
                                                                <td>{aSource.id}</td>
                                                                <td>{aSource.personal_user_name}</td>
                                                                <td>{aSource.lead_process}</td>
                                                                <td>{aSource.lead_status}</td>
                                                                <td>{getDateFormatted(aSource.created_at)}</td>
                                                            </tr>
                                                            {comments}
                                                        </>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                :null
                            }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                            {
                                leadSelected!==null&&leadSelected.distribution.length?
                                    <table className="table bg-table-distribution-row" style={{marginBottom: 0}}>
                                        <thead>
                                            <tr>
                                                <th colSpan={7}>DISTRIBUCIÓN</th>
                                            </tr>
                                            <tr>
                                                <th style={{fontSize: 11}}>No.Pago</th>
                                                <th style={{fontSize: 11}}>Percent</th>
                                                <th style={{fontSize: 11}}>Detalle</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                leadSelected.distribution.map((aSource,idxSource)=>{                                                    
                                                    return (
                                                        <>
                                                            <tr key={`tr-row-key-distribution-row-${idxSource}`}>
                                                                <td>{aSource.no_payment}</td>
                                                                <td>{aSource.percent}%</td>
                                                                <td>{aSource.lead_quote_details}</td>                                                                
                                                            </tr>
                                                        </>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                :null
                            }
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={()=>setModal(false)}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    </>
    )
}

export default Report;